module.exports = __webpack_public_path__ + "static/media/close-icon-light.17040c7f.svg";